import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./DetalleProduct.css";
import { productosData } from "./InfoProduct/infoProduct";

const DetalleProduct = () => {
  const { nombre, subtitulo } = useParams(); // Obtén la categoría y subcategoría desde la URL
  const navigate = useNavigate();

  const productos = productosData[nombre]?.[subtitulo] || []; // Obtén los productos filtrados
  const [currentIndex, setCurrentIndex] = useState(0);

  const productoActual = productos[currentIndex];

  // Funciones de navegación
  const handlePrev = () =>
    setCurrentIndex((prev) => (prev === 0 ? productos.length - 1 : prev - 1));
  const handleNext = () =>
    setCurrentIndex((prev) => (prev === productos.length - 1 ? 0 : prev + 1));
  const handleBack = () => navigate(-1);

  // Función de contacto por WhatsApp
  const handleContact = () => {
    const phoneNumber = "51976492175"; 
    const message = `Hola, estoy interesado en el producto: ${productoActual.name}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank"); 
  };

  if (!productoActual) {
    return (
      <div className="producto-detalle-container">
        <button className="producto-regresar-btn" onClick={handleBack}>
          ← Regresar
        </button>
        <h2>Producto no encontrado</h2>
      </div>
    );
  }

  return (
    <div className="producto-detalle-container">
      <button className="producto-regresar-btn" onClick={handleBack}>
        ← Regresar
      </button>
      <h1 className="producto-detalle-titulo">{productoActual.name}</h1>
      <div className="producto-detalle-card">
        <img
          src={productoActual.image}
          alt={productoActual.name}
          className="producto-detalle-imagen"
        />
        <p className="producto-detalle-descripcion">{productoActual.description}</p>
        <button className="producto-detalle-contacto-btn" onClick={handleContact}>
          <FontAwesomeIcon fontSize={30} icon={faWhatsapp} />
        </button>
      </div>
      <div className="producto-detalle-navegacion">
        <button onClick={handlePrev} className="producto-detalle-nav-btn">
          ← Anterior
        </button>
        <button onClick={handleNext} className="producto-detalle-nav-btn">
          Siguiente →
        </button>
      </div>
    </div>
  );
};

export default DetalleProduct;
